import {
  // read entity
  REQUESTED_API_ENTITY,
  REQUESTED_API_ENTITY_SUCCEEDED,
  REQUESTED_API_ENTITY_FAILED,
  // read list
  REQUESTED_API_ENTITY_LIST,
  REQUESTED_API_ENTITY_LIST_SUCCEEDED,
  REQUESTED_API_ENTITY_LIST_FAILED,
} from "./types"
// read one
export const requestApiEntity = config => {
  return { type: REQUESTED_API_ENTITY, config }
}

export const requestApiEntitySuccess = (action, response) => {
  return { type: REQUESTED_API_ENTITY_SUCCEEDED, action, response }
}

export const requestApiEntityError = (action, error) => {
  return { type: REQUESTED_API_ENTITY_FAILED, action, error }
}

// read list
export const requestApiEntityList = config => {
  return { type: REQUESTED_API_ENTITY_LIST, config }
}

export const requestApiEntityListSuccess = (action, response) => {
  return { type: REQUESTED_API_ENTITY_LIST_SUCCEEDED, action, response }
}

export const requestApiEntityListError = (action, error) => {
  return { type: REQUESTED_API_ENTITY_LIST_FAILED, action, error }
}
